import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useFeature } from '../hooks/useFeature';
import './getStarted/GetStarted.css';
import { useGetStarted } from './getStarted/GetStartedContext';
import { startBillingSetup, errorMessage } from '../utils/onboardingApi';

// Club admins only, while the trial gymnast limit applies
export default function GymnastLimitBanner() {
  const { user, isClubAdmin } = useAuth();
  const featureOn = useFeature('getStarted');
  const ctx = useGetStarted(); // the shared checklist data; this banner never fetches
  const applies = isClubAdmin && featureOn && user?.club?.isHouseClub === false;
  const gymnasts = ctx?.data?.gymnasts || null;
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  if (!applies || !gymnasts || gymnasts.limit == null) return null;

  const start = async () => {
    setBusy(true);
    setError('');
    try {
      await startBillingSetup();
    } catch (err) {
      setError(errorMessage(err));
      setBusy(false);
    }
  };

  return (
    <div className="gymnast-limit-banner" role="status">
      <span>{gymnasts.count} of {gymnasts.limit} gymnasts while you try things out.</span>
      <button type="button" className="gymnast-limit-banner__btn" disabled={busy} onClick={start}>
        {busy ? 'Opening Stripe...' : 'Set up paying Run The Club'}
      </button>
      {error && <span className="gymnast-limit-banner__error" role="alert">{error}</span>}
    </div>
  );
}
